import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import DescriptionBox from '../descriptionBox/DescriptionBox';
import { selectCurrentUser } from '../../pages/login/authSlice';

interface FeedbackProps {
    hideFunction: React.Dispatch<React.SetStateAction<boolean>>;
    disagreeFeedback: string;
    setDisagreeFeedback: React.Dispatch<React.SetStateAction<string>>;
    onButtonClick: (feedbackColumn: string) => void;
    thumbdownFeedbackColumn: string;
    insightFeedbackData: any;
}

export const ThumbDownFeedback = ({
    insightFeedbackData,
    hideFunction,
    disagreeFeedback,
    setDisagreeFeedback,
    onButtonClick,
    thumbdownFeedbackColumn,
}: FeedbackProps) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    useEffect(() => {
        if (insightFeedbackData && thumbdownFeedbackColumn) {
            const feedbackMapping: { [key: string]: any } = {
                coachingPoints: insightFeedbackData?.coaching_points_feedback,
                strengths: insightFeedbackData?.strengths_feedback,
                technicalIssues: insightFeedbackData?.technical_issues_feedback,
            };
            const rating = feedbackMapping[thumbdownFeedbackColumn];
            setDisagreeFeedback(rating);
        }
    }, [insightFeedbackData, thumbdownFeedbackColumn]);

    const handleDescriptionChange = (value: string) => {
        setDisagreeFeedback(value);
    };

    return (
        <div>
            <div className="row mt-3">
                <div className="col-md-12">
                    <DescriptionBox
                        createdByLabel="Author"
                        createdByValue={loggedEmpUserName}
                        title={'Do you want to send Feedback?'}
                        responseDescription={disagreeFeedback}
                        value={disagreeFeedback}
                        limit={200}
                        onChange={handleDescriptionChange}
                        placeholder="Feedback"
                    />
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 float-end mt-3">
                <Button
                    label="Cancel"
                    onClick={() => hideFunction(false)}
                    className="btn-secondary me-2"
                    style={{ borderRadius: '12px' }}
                />
                <Button
                    label="Send"
                    onClick={() => {
                        if (disagreeFeedback?.replace(/^\s+|\s+$/gm, '').length > 0)
                            onButtonClick(thumbdownFeedbackColumn);
                        else toast.warn('Please enter feedback');
                    }}
                    className="btn-primary"
                    style={{ borderRadius: '12px' }}
                />
            </div>
        </div>
    );
};
